import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import LinkCard from "../components/LinkCard";
import { getGroupLink } from "../redux/actions/dataActions";


const styles = {
  root: {
    minWidth: "275px",
  },
  center: {
    margin: "auto 1em auto 1em",
    minWidth: "275px",
  },
  containerCentral: {
    justifyContent: "center",
  },
  lightText: {
    fontWeight: "100",
  },
};

export class kadagroup extends Component {
  componentDidMount() {
    this.props.getGroupLink();
    const script = document.createElement("script");
    script.src = "js/fbmessenger.js";
    script.async = true;
    document.head.appendChild(script);
  }

  render() {
    const { groupLink, loading } = this.props.data; 
    const { classes } = this.props;
    // // disabled for autopilot
    // let groupSetup;
    // if (loading) {
    //   groupSetup = (
    //     <div style={{ display: "flex", justifyContent: "center" }}>
    //       <CircularProgress />
    //     </div>
    //   );
    // } else {
    //   groupSetup = (
    //     <LinkCard
    //     title="Exploration Sprint"
    //     link = {groupLink.groupLink}
    //     linkName="Join Your Chat Group"
    //     groupName={groupLink.group}
    //     />
    //   );
    // }
     
    return (
      <Grid container className={classes.containerCentral}>
        <Grid item sm />
        <Grid item sm className={classes.center}>
          <Typography variant="h3">Connect with Kada</Typography>
            <Card className={classes.root} variant="outlined">
              <CardContent>
                <Typography variant="h4">Talk to Us</Typography>
                <Typography>
                  Kung may problema sa app o kailangan mo ng tulong, message mo lang kami! 😄
                </Typography>
                <Typography>
                  You can use the Facebook chat plugin sa bottom right corner 📳
                </Typography>
              </CardContent>
            </Card>
            
          <div id="fb-root" />
            {/* Your Chat Plugin code */}
            <div className="fb-customerchat" attribution="setup_tool" page_id={100214701807499}>
          </div>
        </Grid>
        <Grid item sm />
      </Grid>
    );
  }
}

kadagroup.propTypes = {
  getGroupLink: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  data: state.data,
});

export default connect(mapStateToProps, { getGroupLink })(
  withStyles(styles)(kadagroup)
);
